export const taxationTypesENUM = {
  REAL: "REAL",
  PRESUMED: "PRESUMED",
  SIMPLE: "SIMPLE",
};
